import React from 'react';
import { BsCardText } from '@react-icons/all-files/bs/BsCardText';

import { decorateComponent } from '../../../documentComponents';
import { TextTabItem } from './TextTabItem';
import { TextTabItemInspector } from './TextTabItem.Inspector';

export default decorateComponent(TextTabItem, 'block', {
  id: 'textTabItem',
  label: '텍스트 탭 항목',
  allowedParent: ['stickyTabItem'],
  allowedChildren: [],
  defaultProps: {},
  disabledDelete: true,
  disabledClone: true,
  disabledMove: true,
  renderIcon: () => <BsCardText />,
  renderInspector: TextTabItemInspector,
});
